import React from 'react';
import './Nodata.scss';

export default function Nodata({
  titleContent,
  textContent,
  subTitleContent,
  className,
}) {
  return (
    <div className='NodataWrapper'>
      <div className={`${className} NodataWrapper--content`}>
        {/* Content No Data Wrapper */}
        <img alt='no data' src='/assets/images/cabinet.svg' />
        <div>
          <h1 className='title-nodata'>{titleContent}</h1>
          <p className='text-nodata'>{textContent}</p>
          <p className='text-nodata'>{subTitleContent}</p>
        </div>
      </div>
    </div>
  );
}
